import styled from '@emotion/styled';

export const TextSimilarityDescriptionContainer = styled.div`
  color: ${({ theme }) => theme.palette.common.black};
`;
